<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: '2040Mesh',

    metaInfo: { title: '2040Mesh' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'Producto2040Mesh',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: '2040Mesh',
      },
    },
  }
</script>
